




    import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
    import dataProxy from "@/services/data-proxy.service"
    import {TipVozila} from "@/services/BackendProxies";

@Component({})
export default class TipoviVozilaEditor extends Vue {
    tipoviVozila = [];
    @Prop() value !: string;

    model = '';

    async created() {
        const tipovi = this.tipoviVozila = await dataProxy.vratiTipoveVozila();
        tipovi.unshift(TipVozila.fromJS({id: '', naziv: '...'}));
        this.tipoviVozila = tipovi.map(t => ({id: t.id, text: t.naziv}));
        this.model = this.value;
    }

    @Watch("value") onValueChange(val) {
        this.model = val;
    }

    @Watch("model") onModelChange(val) {
        this.input(val);
    }

    @Emit() input(val) {

    }
}
